<template>
  <div class="consider__form">
    <div class="page-title mb-2">สร้างแบบฟอร์มพิจารณา</div>

    <div class="text-center mb-4">
      <div class="font-32 font-w-700 font-ch">แบบฟอร์มพิจารณาโครงการ</div>
      <div class="font-20 font-w-700 font-ch" style="color: #f7941d">
        (Consider Form)
      </div>
    </div>

    <v-form ref="form" v-model="valid" lazy-validation>
      <v-card class="pa-6 section_form mb-3">
        <div class="font-20 font-w-700 font-ch mb-6">ข้อมูลแบบฟอร์ม</div>

        <v-layout style="gap: 20px">
          <v-flex xs8>
            <div class="font-14 font-w-700 font-ch mb-2">
              แผนงานสำหรับสร้างแบบฟอร์ม
            </div>
            <v-text-field
              v-model="form.plan_name"
              outlined
              disabled
              height="40"
              readonly
              background-color="#F5F5F5"
              color="#D3D3D3"
              style="border-radius: 30px"
              :rules="[(v) => !!v || 'กรุณาระบุรหัสแผนงาน']"
              required
            ></v-text-field>
            <!-- <v-select
              :items="plans"
              item-text="plan_name_th"
              item-value="plan_name_th"
              v-model="form.plan_name"
              placeholder="โปรดระบุ"
              outlined
              color="#D3D3D3"
              dense
              menu-props="offsetY"
              return-object
              clearable
              style="border-radius: 30px"
              :class="form.plan_name ? 'active__value' : ''"
              :rules="[(v) => !!v || 'กรุณาระบุแผนงานสำหรับสร้างเเบบฟอร์ม']"
              disabled
              required
              @click:clear="form.plan_name = null"
              @change="onSelectPlan"
            ></v-select> -->
          </v-flex>
          <v-flex xs4>
            <div class="font-14 font-w-700 font-ch mb-2">รหัสแผนงาน</div>
            <v-text-field
              v-model="form.plan_code"
              outlined
              height="40"
              readonly
              background-color="#F5F5F5"
              color="#D3D3D3"
              style="border-radius: 30px"
              :rules="[(v) => !!v || 'กรุณาระบุรหัสแผนงาน']"
              required
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout style="gap: 20px">
          <v-flex xs2>
            <div class="font-14 font-w-700 font-ch mb-2">คะแนนเต็ม</div>
            <v-text-field
              v-model="form.overall_score"
              outlined
              height="40"
              readonly
              background-color="#F5F5F5"
              color="#F7941D"
              style="border-radius: 30px"
              type="number"
              :class="form.overall_score ? 'active__value' : ''"
              required
            ></v-text-field>
          </v-flex>
          <v-flex
            shrink
            class="font-14 font-w-300 font-ch"
            style="padding: 35px 20px 0px 0px"
          >
            คะแนน
          </v-flex>
          <v-flex xs2>
            <div class="font-14 font-w-700 font-ch mb-2">ปีงบประมาณ</div>
            <v-text-field
              v-model="form.year"
              outlined
              height="40"
              color="#F7941D"
              style="border-radius: 30px"
              type="number"
              :class="form.year ? 'active__value' : ''"
              :rules="[
                (v) => !!v || 'กรุณาระบุปีงบประมาณ',
                (v) => (v && v.length == 4) || 'กรุณาระบุปีงบประมาณให้ถูกต้อง',
              ]"
              required
            ></v-text-field>
          </v-flex>
          <v-flex v-if='form.plan_master_id === 5' xs2>
            <div  class="font-14 font-w-700 font-ch mb-2">ร้อยละการผ่านเกณฑ์</div>
            <v-text-field
              v-model="form.acceptance_percent"
              outlined
              height="40"
              color="#F7941D"
              style="border-radius: 30px"
              type="number"
              :class="form.acceptance_percent ? 'active__value' : ''"
              :rules="[
                (v) => !!v || 'กรุณาระบุร้อยละการผ่านเกณฑ์',
                (v) => (v && v <= 100) || 'กรุณาระบุร้อยละการผ่านเกณฑ์ให้ถูกต้อง',
              ]"
              required
            ></v-text-field>
          </v-flex>
        </v-layout>

        <div class="d-flex align-center">
          <div class="font-14 font-w-700 font-ch mr-3">
            สถานะ<span style="color: #f15a29">*</span>
          </div>
          <v-switch
            color="#59CB33"
            dense
            inset
            class="switch-theme"
            v-model="form.status"
            false-value="inactive"
            true-value="active"
            :label="form.status == 'active' ? 'ใช้งานอยู่' : 'ไม่ใช้งาน'"
          ></v-switch>
        </div>
      </v-card>

      <v-card class="pa-6 section_form">
        <v-layout justify-space-between align-center>
          <v-flex shrink>
            <div class="font-20 font-w-700 font-ch">ประเภท/รายละเอียด</div>
          </v-flex>
          <v-flex shrink>
            <v-btn
              depressed
              height="35px"
              style="border-radius: 30px"
              color="#F15A29"
              dark
              @click="addDetail()"
            >
              <span class="font-12 font-w-700 font-ch">
                + เพิ่มประเภท/รายละเอียด
              </span>
            </v-btn>
          </v-flex>
        </v-layout>

        <v-card
          class="mb-3 py-6 mt-5 section_form"
          v-for="(item, i) in form.details"
          :key="i"
          style="position: relative"
        >
          <v-btn
            width="20"
            height="20"
            style="position: absolute; top: 10px; right: 10px"
            fab
            dark
            depressed
            color="#B1B1B1"
            @click="deleteDetail(i)"
            v-if="form.details.length > 1"
          >
            <v-icon small>mdi-close</v-icon>
          </v-btn>

          <v-layout px-6 style="gap: 20px">
            <v-flex xs6>
              <div class="font-14 font-w-700 font-ch mb-2">
                ข้อที่ {{ item.criteria_no }}
              </div>
              <v-text-field
                v-model="item.name"
                outlined
                height="40"
                color="#F7941D"
                style="border-radius: 30px"
                placeholder="โปรดระบุ"
                :class="item.name ? 'active__value' : ''"
                :rules="[(v) => !!v || 'กรุณาระบุ']"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs6 >
              <v-layout >
                <v-flex :xs="form.plan_master_id === 5 ? 4 : 6">
                  <div class="font-14 font-w-700 font-ch mb-2">คะเเนน</div>
                  <v-text-field
                    v-model="item.max_score"
                    outlined
                    height="40"
                    color="#F7941D"
                    style="border-radius: 30px; margin-right: 5px"
                    type="number"
                    placeholder="โปรดระบุ"
                    :class="item.max_score ? 'active__value' : ''"
                    :rules="[(v) => !!v || 'กรุณาระบุคะเเนน']"
                    required
                    @input="calculateScore()"
                  ></v-text-field>
                </v-flex>
                <v-flex v-if='form.plan_master_id === 5' xs4>
                  <div class="font-14 font-w-700 font-ch mb-2">ค่าถ่วงน้ำหนัก </div>
                  <v-text-field
                    v-model="item.score_weight"
                    outlined
                    height="40"
                    color="#F7941D"
                    style="border-radius: 30px; margin-left: 5px"
                    type="number"
                    placeholder="โปรดระบุ"
                    :class="item.score_weight ? 'active__value' : ''"
                    :rules="[(v) => !!v || 'กรุณาระบุค่าถ่วงน้ำหนัก ']"
                    required
                    @input="calculateScore()"
                  ></v-text-field>
                </v-flex>
                <v-flex :xs="form.plan_master_id === 5 ? 4 : 6">
                  <v-layout style="padding-top: 2.5rem; padding-left: 1rem">
                    <v-flex shrink class="font-14 font-w-700 font-ch mr-3">
                      รายละเอียดย่อย
                    </v-flex>
                    <v-flex shrink>
                      <v-switch
                        color="#59CB33"
                        dense
                        inset
                        class="switch-theme pa-0 ma-0"
                        v-model="item.have_detail"
                        :label="item.have_detail ? 'มี' : 'ไม่มี'"
                        @click="addSwitchSubDetail(i, item.have_detail)"
                      ></v-switch>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <div v-if="item.have_detail">
            <v-divider class="my-4" style="border-width: 1px"></v-divider>

            <div v-for="(subDetail, sub)  in item.sub_details" :key="sub">
              <v-layout  style="gap: 20px; ">
                <v-flex class='pl-6' xs6>
                  <div class="font-14 font-w-700 font-ch mb-2">
                    ข้อที่ {{ subDetail.criteria_no }}
                  </div>
                  <v-text-field
                    v-model="subDetail.name"
                    outlined
                    height="40"
                    color="#F7941D"
                    style="border-radius: 30px"
                    placeholder="โปรดระบุ"
                    :class="subDetail.name ? 'active__value' : ''"
                    :rules="item.have_detail ? [(v) => !!v || 'กรุณาระบุ'] : []"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-layout>
                    <v-flex xs4 >
                      <div class="font-14 font-w-700 font-ch mb-2">คะแนน</div>
                      <v-text-field
                        v-model="subDetail.max_score"
                        outlined
                        height="40"
                        color="#F7941D"
                        style="border-radius: 30px; margin-right: 5px"
                        type="number"
                        placeholder="โปรดระบุ"
                        :class="subDetail.max_score ? 'active__value' : ''"
                        :rules="
                          item.have_detail
                            ? [(v) => !!v || 'กรุณาระบุตะแนน']
                            : []
                        "
                        required
                        @input="calculateSubScore(i, sub)"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs4 v-if='form.plan_master_id === 5'>
                      <div  class="font-14 font-w-700 font-ch mb-2">ค่าถ่วงน้ำหนัก</div>
                      <v-text-field
                        v-model="subDetail.score_weight"
                        outlined
                        height="40"
                        color="#F7941D"
                        style="border-radius: 30px; margin-left: 5px"
                        type="number"
                        placeholder="โปรดระบุ"
                        :class="subDetail.score_weight ? 'active__value' : ''"
                        :rules="[(v) => !!v || 'กรุณาระบุค่าถ่วงน้ำหนัก ']"
                        required
                        @input="calculateScore()"
                      ></v-text-field>
                    </v-flex>
                    <v-flex  style="padding-right: 2rem;" xs4>
                      <div style="padding-top: 2.5rem; padding-left: 1rem;">
                        <v-btn
                          v-if="item.sub_details.length > 1"
                          width="20"
                          height="20"
                          fab
                          class="mr-2"
                          depressed
                          dark
                          color="#F15A29"
                          @click="deleteSubDetail(i, sub)"
                        >
                          <v-icon small>mdi-close</v-icon>
                        </v-btn>

                        <v-btn
                          v-if="sub === item.sub_details.length - 1"
                          width="20"
                          height="20"
                          fab
                          depressed
                          dark
                          color="#464647"
                          @click="addSubDetail(i, sub)"
                        >
                          <v-icon small>mdi-plus</v-icon>
                        </v-btn>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </div>
          </div>
        </v-card>
      </v-card>

      <v-layout justify-space-between align-center mt-6>
        <v-flex shrink>
          <v-btn
            width="100"
            height="35"
            depressed
            rounded
            color="#D9D9D9"
            @click="$router.push({ name: 'ConsiderFormList' })"
          >
            <span class="font-14 font-w-700 font-ch">ยกเลิก</span>
          </v-btn>
        </v-flex>
        <v-flex shrink>
          <v-btn
            width="100"
            height="35"
            dark
            rounded
            class="btn_orange_gradient"
            @click="submitForm"
            :loading="loadingBtn"
          >
            <span class="font-14 font-w-700 font-ch">บันทึก</span>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-form>

    <!-- <pre>
      {{ form }}
    </pre> -->

    <v-dialog v-model="dialog" width="500">
      <v-card class="pa-6">
        <div class="text-center">
          <!-- icon success -->
          <v-icon color="#59CB33" size="70" class="mx-auto">
            mdi-check-circle
          </v-icon>
        </div>

        <div class="font-24 font-w-700 font-ch text-center mt-6">
          {{ dialogMsg }}
        </div>

        <div class="d-flex justify-center mt-12">
          <v-btn
            dark
            color="#F15A29"
            width="100"
            rounded
            depressed
            @click="confirmDialog"
          >
            <div class="font-16 font-w-700 font-ch text-center">ตกลง</div>
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import TextField from "../../components/input/TextField";
import SelectBox from "../../components/input/SelectBox";
import Service from "../../services";
export default {
  name: "ConsiderForm",
  components: {
    TextField,
    SelectBox,
  },
  data() {
    return {
      dialog: false,
      valid: true,
      loadingBtn: false,
      dialogMsg: "บันทึกสำเร็จ",
      plans: [
        // {
        //   plan_name_th:
        //     "แผนงานพัฒนาขีดความสามารถทางเทคโนโลยีและวิจัยของภาคเอกชนในพื้นที่ (IRTC)",
        //   plan_code: "1",
        // },
        // {
        //   plan_name_th: "แผนงานวิจัยร่วมกับภาคเอกชน  Collaborative Research",
        //   plan_code: "2",
        // },
        // {
        //   plan_name_th:
        //     "แผนงานบ่มเพาะธุรกิจวิทยาศาสตร์ เทคโนโลยีและนวัตกรรม STI Business Incubation",
        //   plan_code: "3",
        // },
        // {
        //   plan_name_th: "แผนงานพัฒนาบริการอุทยานวิทยาศาสตร์ Service Platform",
        //   plan_code: "4",
        // },
      ],
      form: {
        // ข้อมูลเเบบฟอร์ม
        plan_master_id: null,
        plan_name: null,
        plan_code: null,
        overall_score: null,
        year: null,
        acceptance_percent: null,
        status: "inactive",
        // ประเภท/รายละเอียด
        details: [
          {
            name: null,
            max_score: null,
            have_detail: null,
            score_weight: null,
            criteria_no: 1,
            sub_details: [],
          },
        ],
      },
      condiserId: null,
    };
  },
  created() {
    if (this.$route.params.id) {
      this.getEdit();
    } else {
      this.getCreate();
    }
  },
  methods: {
    async getCreate() {
      const res = await this.$apiFire("Consider/create", this.$route.params.id);
      if (res) {
        this.plans = res.plan_master;
      }
    },
    async getEdit() {
      const res = await this.$apiFire("Consider/edit", this.$route.params.id);
      if (res) {
        this.plans = res.plan_master;
        this.form = {
          plan_master_id: res.EvaluateLayout.plan_master_id,
          plan_name: res.EvaluateLayout.plan_name,
          plan_code: res.EvaluateLayout.plan_code,
          overall_score: res.EvaluateLayout.overall_score,
          acceptance_percent: res.EvaluateLayout.acceptance_percent,
          year: res.EvaluateLayout.year.toString(),
          status: res.EvaluateLayout.status,
          details: res.EvaluateLayout.details,
        };
        this.condiserId = res.EvaluateLayout.id;
      }
    },
    onSelectPlan(event) {
      if (event) {
        this.form.plan_master_id = event.id;
        this.form.plan_name = event.plan_name_th;
        this.form.plan_code = event.plan_code;
      }
    },
    calculateScore() {
      // sum max score in details to overall score
      this.form.overall_score = this.form.details.reduce((acc, cur) => {
        return acc + +cur.max_score;
      }, 0);
      this.form.overall_score =
        this.form.overall_score == 0 ? null : this.form.overall_score;
    },
    calculateSubScore(index) {
      // sum max score in sub_details to max score details
      this.form.details[index].max_score = this.form.details[index].sub_details.reduce((acc, cur) => {
        return acc + +cur.max_score;
      }, 0);
      this.form.details[index].max_score =
        this.form.details[index].max_score == 0 ? null : this.form.details[index].max_score;
      this.calculateScore()
    },
    addDetail() {
      this.form.details.push({
        name: null,
        max_score: null,
        have_detail: false,
        criteria_no: this.form.details.length + 1,
        sub_details: [],
      });
    },
    deleteDetail(index) {
      this.form.details.splice(index, 1);

      // เรียงลำดับ criteria_no ใหม่
      this.form.details.forEach((item, i) => {
        item.criteria_no = i + 1;
      });
    },
    addSwitchSubDetail(index, val) {
      console.log(index, val);
      // ถ้า val มีค่า ให้เพิ่ม subDetail ใหม่ ถ้าไม่มีให้ลบ subDetail ออก
      if (val) {
        this.form.details[index].sub_details = [
          {
            name: null,
            criteria_no: index + 1 + ".1",
            max_score: null,
          },
        ];
      } else {
        this.form.details[index].sub_details = [];
      }
    },
    addSubDetail(index, subIndex) {
      console.log(index);
      this.form.details[index].sub_details.push({
        name: null,
        criteria_no: index + 1 + "." + (subIndex + 2),
        max_score: null,
      });
      // force re-render
      this.$forceUpdate();
    },
    deleteSubDetail(index, subIndex) {
      this.form.details[index].sub_details.splice(subIndex, 1);

      // เรียงลำดับ criteria_no ใหม่
      this.form.details[index].sub_details.forEach((item, i) => {
        item.criteria_no = index + 1 + "." + (i + 1);
      });

      // force re-render
      this.$forceUpdate();
    },
    async submitForm() {
      // validate form
      if (this.$refs.form.validate()) {
        this.form.overall_score = +this.form.overall_score;
        if (this.$route.params.id) {
          const res = await this.$apiFire("Consider/update", {
            id: this.condiserId,
            data: this.form,
          });
          if (res) {
            this.$router.push({ name: "ConsiderFormList" });
          }
        } else {
          const res = await this.$apiFire("Consider/save", this.form);
          if (res) {
            this.$router.push({ name: "ConsiderFormList" });
          }
        }
      }
    },
    confirmDialog() {
      this.dialog = false;
      if (this.dialogMsg == "เกิดข้อผิดพลาด") {
        return;
      } else {
        this.$router.push({ name: "ConsiderFormList" });
      }
    },
  },
};
</script>

<style lang="scss">
.consider__form {
  .v-menu__content {
    border-radius: 30px !important;
  }
  .section_form {
    background: #ffffff;
    box-shadow: 1px 1px 30px rgba(0, 0, 0, 0.1) !important;
    border-radius: 20px;
  }

  .btn-create-consider {
    background: linear-gradient(21.01deg, #f15a29 6.18%, #fbb040 84.83%);
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.25);
    border-radius: 30px;
    height: 30px;
    padding: 0px 10px;
  }
  .active__value {
    .v-input__slot fieldset {
      border: 1px solid #f15a29 !important;
    }
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
  }

  input[type="number"] {
    -moz-appearance: textfield; /* Firefox */
  }

  .btn_orange_gradient {
    background: linear-gradient(21.01deg, #f15a29 6.18%, #fbb040 84.83%);
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.25);
    border-radius: 30px;
  }
}
</style>
